document.documentElement.classList.add("is-ready");

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("[data-site-header]");
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const menu = document.querySelector("#primary-menu");
  const cartToggle = document.querySelector("[data-cart-toggle]");
  const cartDrawer = document.querySelector("[data-cart-drawer]");

  if (!header) {
    return;
  }

  const updateHeaderState = () => {
    if (window.scrollY > 48) {
      header.classList.add("is-scrolled");
      return;
    }

    if (window.scrollY < 12) {
      header.classList.remove("is-scrolled");
    }
  };

  const closeMenu = () => {
    header.classList.remove("is-menu-open");

    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "false");
    }
  };

  const openMenu = () => {
    header.classList.add("is-menu-open");

    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "true");
    }
  };

  const closeCart = () => {
    header.classList.remove("is-cart-open");
    document.documentElement.classList.remove("is-cart-open");

    if (cartToggle) {
      cartToggle.setAttribute("aria-expanded", "false");
    }

    if (cartDrawer) {
      cartDrawer.setAttribute("aria-hidden", "true");
    }
  };

  const openCart = () => {
    closeMenu();
    header.classList.add("is-cart-open");
    document.documentElement.classList.add("is-cart-open");

    if (cartToggle) {
      cartToggle.setAttribute("aria-expanded", "true");
    }

    if (cartDrawer) {
      cartDrawer.setAttribute("aria-hidden", "false");

      const closeButton = cartDrawer.querySelector("[data-cart-close]");

      if (closeButton) {
        closeButton.focus();
      }
    }
  };

  updateHeaderState();
  window.addEventListener("scroll", updateHeaderState, { passive: true });

  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener("click", () => {
      if (header.classList.contains("is-cart-open")) {
        closeCart();
        return;
      }

      openCart();
    });

    cartDrawer.addEventListener("click", (event) => {
      if (event.target.closest("[data-cart-close]")) {
        closeCart();
        cartToggle.focus();
      }
    });
  }

  if (menuToggle && menu) {
    menuToggle.addEventListener("click", () => {
      if (header.classList.contains("is-menu-open")) {
        closeMenu();
        return;
      }

      closeCart();
      openMenu();
    });

    menu.addEventListener("click", (event) => {
      if (event.target.closest("a")) {
        closeMenu();
      }
    });
  }

  document.addEventListener("click", (event) => {
    if (menuToggle && menu && !header.contains(event.target)) {
      closeMenu();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
      closeCart();

      if (menuToggle) {
        menuToggle.focus();
      }
    }
  });
});
